<template>
    <ies-form-field :field="field">
        <div class="checkbox">
            <input :name="this.field.fieldName"
                   type="checkbox"
                   v-model="input"
                   v-on:change="updateField()"
                   :disabled="this.field.disabled">
        </div>
    </ies-form-field>
</template>

<script>
export default {
    name: 'ies-text',
    props: ['field'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
        return {
            input: (this.field.value == '1' ? 1 : 0)
        }
    },
    methods: {
    	updateField: function(){
        	this.field.value = this.input
    	}
    }
}
</script>
